import { TESTIMONIALS } from '../../../mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-24" style={{ background: '#f0fdfa' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider mb-4 border"
            style={{ background: 'white', borderColor: 'color-mix(in srgb, var(--primary) 30%, transparent)', color: 'var(--primary-dark)' }}
          >
            CUSTOMER STORIES
          </div>
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-gray-900 mb-4">
            Trusted by Thousands of{' '}
            <span style={{ color: 'var(--primary)' }}>Happy Shippers</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            From small businesses to global enterprises — see why our customers never look back.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-7 border border-gray-100 flex flex-col"
              style={{ boxShadow: '0 2px 12px rgba(13,148,136,0.06)' }}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${i < t.rating ? 'text-amber-400' : 'text-gray-200'}`}
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1 mb-6">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 border-t border-gray-50 pt-5">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover object-top flex-shrink-0"
                />
                <div className="min-w-0">
                  <div className="font-semibold text-gray-900 text-sm truncate">{t.name}</div>
                  <div className="text-gray-500 text-xs truncate">{t.role} · {t.company}</div>
                </div>
                <div className="ml-auto flex-shrink-0 text-right">
                  <div className="font-bold text-sm" style={{ color: 'var(--primary)' }}>
                    {t.shipments.toLocaleString()}
                  </div>
                  <div className="text-gray-400 text-xs">shipments</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
